import React, { useState } from 'react';
import { Check, ArrowRight } from 'lucide-react';
import { industries, BOOKING_URL } from '../mock';

export default function WhoWeServe() {
  const [active, setActive] = useState(0);
  const item = industries[active];

  return (
    <section id="who-we-serve" className="relative py-24 lg:py-32 bg-white border-y border-[#e8e4d8]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mb-12">
          <p className="text-xs uppercase tracking-[0.3em] text-[#ea580c] mb-4 font-semibold">Who we serve</p>
          <h2 className="font-display text-3xl md:text-5xl font-semibold text-[#0b0f0d] leading-tight">
            Built exclusively for local service contractors.
          </h2>
          <p className="mt-5 text-[#4a4f4c] text-lg">
            We only work with six trades, and one contractor per city, per trade. That focus is why our campaigns outperform generalists three to four times over.
          </p>
        </div>

        <div className="grid lg:grid-cols-[300px_1fr] gap-6">
          <div className="flex lg:flex-col gap-2 overflow-x-auto lg:overflow-visible pb-2 lg:pb-0">
            {industries.map((ind, i) => (
              <button
                key={ind.key}
                onClick={() => setActive(i)}
                className={`shrink-0 lg:w-full text-left px-5 py-4 rounded-xl border font-display font-semibold flex items-center gap-4 ${
                  active === i
                    ? 'bg-[#0b0f0d] text-white border-[#0b0f0d]'
                    : 'bg-[#faf9f5] text-[#0b0f0d] border-[#e8e4d8] hover:border-[#0b0f0d]/40'
                }`}
              >
                <span className={`text-xs ${active === i ? 'text-[#ea580c]' : 'text-[#8a8a80]'}`}>{ind.tag}</span>
                <span>{ind.label}</span>
              </button>
            ))}
          </div>

          <div className="relative rounded-3xl border border-[#e8e4d8] bg-[#faf9f5] p-6 lg:p-10 overflow-hidden">
            <div className="grid md:grid-cols-2 gap-8 items-center">
              <div>
                <div className="text-[#ea580c] text-sm font-semibold mb-3">{item.tag} . {item.label}</div>
                <h3 className="font-display text-2xl md:text-3xl font-semibold text-[#0b0f0d] leading-tight">{item.title}</h3>
                <p className="mt-4 text-[#4a4f4c] leading-relaxed">{item.desc}</p>
                <div className="mt-6 space-y-2.5">
                  {['Exclusive to your service area', 'Pre-screened, in-market leads', 'Weekly performance reports'].map((b) => (
                    <div key={b} className="flex items-center gap-3 text-sm text-[#0b0f0d]">
                      <div className="w-5 h-5 rounded-full bg-[#0b0f0d] flex items-center justify-center text-white">
                        <Check size={12} />
                      </div>
                      {b}
                    </div>
                  ))}
                </div>
                <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="mt-8 inline-flex items-center gap-2 text-[#0b0f0d] hover:text-[#ea580c] font-semibold text-sm">
                  Claim your area <ArrowRight size={16} />
                </a>
              </div>
              <div className="relative aspect-[4/3] rounded-2xl overflow-hidden">
                <img src={item.img} alt={item.label} className="w-full h-full object-cover" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
